<template>
  <v-card
    outlined
    elevation="0"
    class="base-details-card"
    v-bind="$attrs"
    v-if="
      (data && Object.keys(data).length > 0) ||
      contextValue != null ||
      isShowOnly
    "
  >
    <v-expansion-panels v-model="panel" :disabled="disabledExpand" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header
          class="grey py-0 px-2 d-flex justify-space-between"
        >
          <v-card-title class="py-1 d-flex justify-space-between">
            <span
              v-if="title"
              class="cf-info-title font-weight-bold text-uppercase d-flex align-center"
              style="opacity: 0.7; color: black !important"
            >
              <v-icon
                class="mr-2"
                v-if="icon"
                :color="getOrderStatusColor(status)"
              >
                {{ icon }}
              </v-icon>
              {{ title }}
            </span>
            <slot name="header"></slot>
          </v-card-title>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" v-if="data && Object.keys(data).length > 0">
                <v-row
                  no-gutters
                  v-for="(value, name, index) in data"
                  :key="index"
                >
                  <v-col
                    cols="6"
                    class="py-1"
                    v-if="name  != 'id' && keysToIgnore.indexOf(name) == -1 && value != null"
                  >
                    <span
                      class="cf-info-title font-weight-regular text-capitalize"
                    >
                      {{ `${name.replace(/_/g, " ")}`.toLowerCase() }}
                    </span>
                  </v-col>
                  <v-col
                    cols="6"
                    v-if="name  != 'id' && keysToIgnore.indexOf(name) == -1 && value != null"
                    class="d-flex justify-end py-1"
                  >
                    <span class="cf-info-title font-weight-bold">
                      {{
                        typeof value == typeof true
                          ? value
                            ? "Yes"
                            : "No"
                          : value
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="contextValue != null">
              <v-col cols="12">
                <span class="cf-info-title font-weight-regular text-capitalize">
                  {{ contextValue }}
                </span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col
                cols="12"
                class="cf-info-title font-weight-regular text-capitalize"
              >
                <slot name="information"></slot>
              </v-col>
            </v-row>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    isShowOnly: {
      type: Boolean,
    },
    disabledExpand: {
      type: Boolean,
    },
    contextValue: {
      type: [String, Number],
    },
    status: {
      type: String,
    },
    icon: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    keysToIgnore: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      panel: [0],
    };
  },
};
</script>

<style scoped>
.v-expansion-panel::before {
  box-shadow: none !important;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: inherit !important;
}
</style>
